__turbopack_context__.v({
  "article": "RelatedArticles-module-scss-module__yRL8Va__article",
  "article__meta": "RelatedArticles-module-scss-module__yRL8Va__article__meta",
  "articles": "RelatedArticles-module-scss-module__yRL8Va__articles",
  "header": "RelatedArticles-module-scss-module__yRL8Va__header",
  "list": "RelatedArticles-module-scss-module__yRL8Va__list",
  "viewall": "RelatedArticles-module-scss-module__yRL8Va__viewall",
  "wrapper": "RelatedArticles-module-scss-module__yRL8Va__wrapper",
});
